<template>
    <vx-card id="loader">
        <h3 class="mb-4">Коэффициенты типов баинга SSP={{ sspId }}</h3>

        <div class="vx-row mt-1">
            <!-- <div class="vx-col w-5/6 mb-1">
                <div class="mt-1">
                    <vs-button id="createButton" color="success" @click="create()" type="filled">
                        Добавить
                    </vs-button>
                </div>
            </div> 

            <div class="vx-col w-1/6 mb-1">
                <div class="mt-1 pt-3">
                    <v-select
                        :options="dicts.pageSizes"
                        label="name"
                        placeholder="На странице..."
                        class="w-full"
                        v-model="pageSize"
                        :clearable="false"
                        @input="changePageSize()"
                    >
                    </v-select>
                </div>
            </div> -->
        </div>

        <vs-table stripe :data="items" max-items="25">
            <template slot="header"></template>
            <template slot="thead">
                <vs-th>Тип баинга</vs-th>
                <vs-th>Страна</vs-th>
                <vs-th>Коэффициент</vs-th>
                <vs-th>#</vs-th>
            </template>

            <template v-for="(gr, indextr) in items">
                <vs-tr>
                    <vs-td colspan="4" class="cursor-pointer">
                        <div class="w-full" @click="showCoeffs(gr)">
                            <feather-icon
                                :icon="gr.show ? 'ChevronDownIcon' : 'ChevronRightIcon'"
                                class="inline-block mr-2 cursor-pointer"
                                svgClasses="w-5 h-5"
                            />
                            {{ gr.buyingTypeName  }}
                        </div>
                    </vs-td>
                </vs-tr>

                <template v-if="gr.show" v-for="c in gr.coeffs">
                    <vs-tr>
                        <vs-td></vs-td>
                        <vs-td>{{ c.countryName }}</vs-td>
                        <vs-td class="vs-lg-4"><vs-input type="number" v-model="c.coeff" autocomplete="off" class="mt-1 w-1/3" /></vs-td>
                        <vs-td>
                            <div>
                                <div class="inline-block cursor-pointer">
                                    <vx-tooltip text="Сохранить" position="top" delay=".3s">
                                        <feather-icon
                                            @click="saveChanges(c)"
                                            icon="SaveIcon"
                                            class="inline-block mr-2 text-success"
                                            svgClasses="w-7 h-7"
                                        />
                                    </vx-tooltip>
                                </div>  
                            </div>
                        </vs-td> 
                    </vs-tr>
                </template> 
            </template>
        </vs-table>

        <vs-pagination :max="5" :total="pagesTotal" v-model="page" class="mt-3"></vs-pagination>
    </vx-card>
</template>

<script>
import axios from 'axios';
import vSelect from 'vue-select';

export default {
    name: 'buying-type-coeffs',
    props: ['sspId'],
    data() {
        return {
            items: [],
            initialized: false,
            page: 1,
            pageSize: 100,
            pagesTotal: 1,
            dicts: {
                pageSizes: [25, 50, 100, 500]
            }
        };
    },
    components: {
        vSelect
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = {
                sspId: this.sspId,
                page: this.page,
                size: this.pageSize
            };

            this.axios
                .all([
                    this.axios.get('buying-type-coeffs/grouped', {params: params}),
                    // this.axios.get('buying-type-coeffs/count', {params: params})
                ])
                .then(
                    axios.spread((items/*, count*/) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.items = items.data;
                        // this.pagesTotal = Math.ceil(count.data / this.pageSize);
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки коэффициентов.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        saveChanges(tr) {
            const params = {
                id: tr.id,
                sspTypeId: tr.sspTypeId,
                buyingTypeId: tr.buyingTypeId,
                countryId: tr.countryId,
                coeff: tr.coeff
            };
            this.$axios({
                method: 'PUT',
                url: 'buying-type-coeffs/' + tr.id,
                params: params,
                errors: this.errors,
                success: (response) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Коэффициент успешно обновлен',
                        color: 'success'
                    });
                    // this.loadData();
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    debugger
                    if (err.request.status == 422 && err.data.errors) {
                        const errors = Object.values(err.data.errors)[0];
                        return this.$vs.notify({
                            title: 'Внимание!',
                            text: errors[0],
                            color: 'danger'
                        });
                    }

                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при обновлении коэффициента!',
                        color: 'danger'
                    });
                }
            });
        },
        showCoeffs(group) {
            group.show = !group.show;
            this.$forceUpdate();
        },
        changePageSize() {
            this.page = 1;

            this.loadData();
        },
        create() {
            this.$router.push({ name: 'buying-type-coeff-create', params: { sspId: this.sspId } });
        },
    },
    watch: {
        page: function () {
            this.loadData();
        }
    },
    mounted() {
        this.loadData();
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
    tr > td.actions {
        white-space: nowrap;
    }
    tr > td {
        word-break: break-all;
    }
}
thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}
.vs-pagination--mb {
    justify-content: center !important;
}
</style>
